export default __webpack_public_path__ + "static/media/WM0530.34I-43588_-26015_0.6d256a46.jpg";